<template>
  <div class="timeline-container">
    <!-- 🌸 Flores decorativas -->
    <img
      ref="flor1"
      src="@/assets/elementos2.png"
      alt="flor decorativa"
      class="flower-deco flower-top"
    />
    <img
      ref="flor2"
      src="@/assets/elementos2.png"
      alt="flor decorativa"
      class="flower-deco flower-bottom"
    />

    <!-- Overlay principal -->
    <div class="overlay">
      <!-- Título con animación --> <br><br><br><br><br><br><br><br><br><br><br><br><br>
      <div ref="titulo" class="text">Regalos</div>
      <div class="text3">
        ¡Que me acompañes es lo más importante! 
      Y si esta en tu disposición realizar una muestra de cariño estaré muy agradecida.
        <br>
      </div>
      <!-- Overlay 4 -->
      <div ref="overlay4" class="overlay4">
        <div class="icon222">
          <img src="@/assets/sobrep.png" alt="icon-right" class="icon-image" />
        </div>
        <div class="text3">
          "La lluvia de sobres es la tradición de regalar dinero en efectivo dentro de un sobre el día del evento"
        </div>
      </div>

      <!-- Overlay 5 
      <div ref="overlay5" class="overlay5">
        <div class="icon2222">
          <img src="@/assets/gift.png" alt="icon-right" class="icon-image" />
        </div>
        <div class="text3">¡Regalo sorpresa! Estoy segura que me encantará.</div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'TimelineComponent',
  setup() {
    const flor1 = ref(null)
    const flor2 = ref(null)
    const titulo = ref(null)
    const overlay4 = ref(null)

    const observeAndAnimate = (element, animation) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animation(entry.target)
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.3 })

      observer.observe(element)
    }

    const fadeFromLeft = (el) => {
      gsap.fromTo(el, { x: -150, opacity: 0 }, {
        x: 0, opacity: 1, duration: 1.2, ease: 'power3.out'
      })
    }

    const fadeFromBottom = (el, delay = 0) => {
      gsap.fromTo(el, { y: 50, opacity: 0 }, {
        y: 0, opacity: 1, duration: 1, ease: 'power2.out', delay
      })
    }

    const scaleIn = (el, delay = 0) => {
      gsap.fromTo(el, { scale: 0.7, opacity: 0 }, {
        scale: 1, opacity: 1, duration: 1, ease: 'back.out(1.7)', delay
      })
    }

    onMounted(() => {
      nextTick(() => {
        observeAndAnimate(flor1.value, fadeFromLeft)
        observeAndAnimate(flor2.value, fadeFromLeft)
        observeAndAnimate(titulo.value, (el) => fadeFromBottom(el, 0))
        observeAndAnimate(overlay4.value, (el) => scaleIn(el, 0.2))
      })
    })

    return {
      flor1,
      flor2,
      titulo,
      overlay4,
    }
  },
}
</script>

<style scoped>
.timeline-container {
  position: relative;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 30px;
  background: linear-gradient(rgba(205, 171, 204, 0.662), rgba(219, 197, 217, 0.758)),
    url('@/assets/NIK_4277.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* FLORES */
.flower-deco {
  position: absolute;
  left: 0;
  z-index: 0;
  opacity: 0;
  pointer-events: none;
}

.flower-top {
  top: 80px;
  width: 100px;
  transform: rotate(-10deg);
}

.flower-bottom {
  bottom: 40px;
  width: 90px;
  transform: rotate(8deg);
}

/* Overlays */
.overlay {
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 800px;
  width: 90%;
  margin: 20px auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.overlay4,
.overlay5 {
  border-radius: 10px;
  margin: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 600px;
  text-align: center;
  opacity: 0;
}

/* Icono imagen */
.icon-image {
  width: 80%;
  max-width: 100px;
  height: auto;
}

/* Título principal animado */
.text {
  text-align: center;
  font-size: 46px;
  font-family: 'FeelingPassionate';
  font-weight: 700;
  letter-spacing: 5px;
  color: #3c3737;
  margin-bottom: 40px;
  line-height: 2.5; /* aumenta el espacio entre líneas */

  opacity: 0;
  transform: translateY(30px);
}

/* Texto de bloques */
.text3 {
  font-size: 18px;
  text-align: center;
  color: rgb(42, 39, 39);
  font-family: 'Josefin Sans', sans-serif;
  margin-top: 0px;
  margin-bottom: 20px;
  font-weight: 350;
}

/* Fuente personalizada */
@font-face {
  font-family: 'FeelingPassionate';
  src: url('@/assets/fonts/passionate.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
</style>
